var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconFounding(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_\\uB808\\uC774\\uC5B4_2",
    "data-name": "\\uB808\\uC774\\uC5B4 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .found-1 {\r\n        stroke: #000;\r\n        stroke-linecap: round;\r\n        stroke-linejoin: round;\r\n      }\r\n\r\n      .found-1, .found-2 {\r\n        fill: none;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_\\uB808\\uC774\\uC5B4_1-2",
    "data-name": "\\uB808\\uC774\\uC5B4 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "found-1",
    cx: 8.98,
    cy: 15.36,
    r: 2.28
  }), /*#__PURE__*/React.createElement("path", {
    className: "found-1",
    d: "m8.98,17.64c-.43,0-.83-.13-1.17-.33v17.77h2.34v-17.77c-.34.21-.74.33-1.17.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "found-1",
    d: "m6.84,35.08h4.29c1.01,0,1.84.82,1.84,1.84h-7.96c0-1.01.82-1.84,1.84-1.84Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "found-1",
    cx: 41.02,
    cy: 15.36,
    r: 2.28
  }), /*#__PURE__*/React.createElement("path", {
    className: "found-1",
    d: "m41.02,17.64c-.43,0-.83-.13-1.17-.33v17.77h2.34v-17.77c-.34.21-.74.33-1.17.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "found-1",
    d: "m38.87,35.08h4.29c1.01,0,1.84.82,1.84,1.84h-7.96c0-1.01.82-1.84,1.84-1.84Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "found-1",
    d: "m19.89,23.76c-.45-.78-.53-1.68-.29-2.48-3.3-.47-6.47-1.34-9.45-2.59v3.58c3.26,1.24,6.72,2.08,10.3,2.47l-.57-.98Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "found-1",
    d: "m25,21.66c-.91,0-1.82-.04-2.72-.11l1.98,3.42c.25,0,.49.02.74.02,5.23,0,10.23-.97,14.85-2.73v-3.58c-4.57,1.92-9.59,2.98-14.85,2.98Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "found-1",
    d: "m29.56,31.03c-.5.29-.88.7-1.14,1.16l-1.68-2.9-.71-1.23-4.98-8.63c-1.52.88-2.04,2.82-1.16,4.34l2.89,5c.33.58.9.99,1.56,1.12s1.23.54,1.56,1.12l2.51,4.35c.87,1.51,2.8,2.03,4.31,1.16s2.03-2.8,1.16-4.31-2.8-2.03-4.31-1.16Zm2.36,4.09c-.75.43-1.71.18-2.14-.57s-.18-1.71.57-2.14,1.71-.18,2.14.57.18,1.71-.57,2.14Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "found-1",
    d: "m26.33,24.96l-1.04,1.8.74,1.29.71,1.23.19.32c.36-.2.67-.49.88-.85l2.36-4.09c-1.26.16-2.54.26-3.84.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "found-1",
    d: "m30.95,21.2c-.23-.72-.71-1.37-1.42-1.78l-1.21,2.09c.88-.08,1.76-.18,2.63-.31Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "found-1",
    d: "m24.34,29.87c-.25-.05-.47-.15-.68-.27l-1.49,2.58c-.27-.46-.65-.87-1.14-1.16-1.51-.87-3.44-.35-4.31,1.16-.87,1.51-.35,3.44,1.16,4.31,1.51.87,3.44.35,4.31-1.16l2.51-4.35c.15-.27.36-.49.61-.68-.28-.21-.6-.37-.96-.44Zm-3.54,4.67c-.43.75-1.39,1.01-2.14.57-.75-.43-1.01-1.39-.57-2.14.43-.75,1.39-1.01,2.14-.57s1.01,1.39.57,2.14Z"
  })), /*#__PURE__*/React.createElement("circle", {
    className: "found-1",
    cx: 25.24,
    cy: 28.95,
    r: 0.15
  }))), /*#__PURE__*/React.createElement("rect", {
    className: "found-2",
    width: 50,
    height: 50
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFounding);
export default __webpack_public_path__ + "static/media/icon-founding.b3a5c70a1ac7fe3b9f4076c5e5065354.svg";
export { ForwardRef as ReactComponent };